import { Paper, Typography, Box } from "@mui/material";
import { MaxItems } from "./MaxItems";

export const PanelBox = ({ title, description, children, count }) => (
  <Paper
    padding={0}
    as={Box}
    elevation={0}
    border="solid 2px #EAECF0"
    minHeight="459px"
  >
    <Box padding="16px 24px" display="flex" alignItems="center">
      <Typography
        variant="body1"
        component="h4"
        sx={{
          fontSize: "16px",
          lineHeight: "18px",
          fontWeight: "bold",
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="subtitle1"
        component="h5"
        paddingLeft={1}
        sx={{
          fontSize: "16px",
          lineHeight: "18px",
        }}
      >
        ({description})
      </Typography>
     {count&& <MaxItems count={count} />}
    </Box>
    {children}
  </Paper>
);
